import React, { useContext, useMemo } from 'react'

import { AutonomousInternshipFormModalContext, Modes } from '../../../../Providers/Forms/InternshipForm/AutonomousInternshipFormModal'
import { Internship } from '../../../../utils/entities/internship'
import { getDisablingState } from '../../InternshipsManager/utils/utils'
import InternshipCard from './InternshipCard'

const ActionInternshipCard = ({ disabled, internship, refresh }) => {
  const { setData } = useContext(AutonomousInternshipFormModalContext)

  const isClickable = useMemo(() => !disabled && !getDisablingState(internship), [disabled, internship])

  const handleClick = () => {
    if (isClickable) {
      setData({ object: new Internship(internship), callback: refresh, mode: Modes.UPDATE })
    }
  }

  return (
    <div className={`internship-info-old ${isClickable ? 'cu-ptr' : 'cu-nt-alwd'}`} onClick={handleClick}>
      <InternshipCard internship={internship} />
    </div>
  )
}

export default ActionInternshipCard
